import { faArrowCircleRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Typography, Row, Col, Space } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCaregivers } from "../../api/Caregivers";
import CaregiverCard from "../../components/CaregiverDisplay/CaregiverCard";
import ContentLayout from "../../layout/ContentLayout";
import { careTypeList } from "../../utils/careCategoryOptions";

const Category = () => {
  const { category } = useParams();
  const target = careTypeList[category];
  return !target ? null : <CategoryResult category={target} />;
};

const CategoryResult = ({ category }) => {
  const [caregivers, setCaregivers] = useState([]);

  const { data } = useCaregivers({ caretype: category.value, limit: 3 });

  useEffect(() => {
    setCaregivers(data?.Users || []);
  }, [data]);

  const navigate = useNavigate();

  return (
    <ContentLayout>
      <div className="jumbotron" style={{ textAlign: "center" }}>
        <Typography.Title level={1}>{category.label}</Typography.Title>
        <Typography.Title level={3} style={{ margin: 0 }} type="secondary">
          {category?.description}
        </Typography.Title>
      </div>
      {category?.extra && (
        <Typography.Title
          level={4}
          style={{ margin: "20px 0", textAlign: "center" }}
        >
          {category.extra}
        </Typography.Title>
      )}
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <Row gutter={[24, 24]}>
          {caregivers.map((caregiver) => (
            <Col xs={24} md={8} key={caregiver.UserId}>
              <CaregiverCard caregiver={caregiver} key={caregiver.UserId} />
            </Col>
          ))}
        </Row>
      </div>
      <div style={{ textAlign: "center" }}>
        <Button
          onClick={() => navigate(`/caregivers?caretype=${category.value}`)}
          size="large"
          type="primary"
        >
          View All {category.label} Providers
        </Button>
      </div>
    </ContentLayout>
  );
};

export default Category;
